import React from 'react'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Routes, Route ,useNavigate } from 'react-router-dom';
import { Button } from "@nextui-org/react";
import './SidePanel.css'

const SidePanel = ({sideMenu,istabselected,SetTabselected,policyName}) => {
    const navigate = useNavigate();
    
        return(
            sideMenu.map((value,index) => {
           
                return (
                    
               <motion.div
               initial={{
                x:"-100%",
                opacity:0
    
            }}
            animate={{
                transition: { 
                    delay: 0.1*index, 
                    duration: 0.5,                              }
                ,
                x:"0%"
                ,
                opacity:1
            }}
               >
                    <Row className='d-flex justify-content-center align-items center side-menu-items mt-1' >
                        <Button disableRipple isDisabled={value.isDisabled} variant="ghost" className={`side-menu-items-btn ${istabselected !== value.url ? 'me-4' : ''}`} onClick={()=>{SetTabselected(value.url);navigate("/customer-portal/"+value.url+"?policy-id="+policyName)}} style={istabselected === value.url ? { color: "white" } : {}}>
                            <Col xs={2} >{value.icon} </Col>
                            <Col className="text-start" xs={8} >{value.label}</Col>
    
                        </Button>
                        <AnimatePresence>
                            {istabselected== value.url && (
                                <motion.span
                                    className="ab-btn"
                                    initial={{ scale: 0 }}
                                    animate={{ scale: 1 , transition: { ease: "easeInOut" }}}
                                    exit={{ scale: 0 }}
                                    
                                ></motion.span>
                            )}
                        </AnimatePresence>
    
                    </Row>
                    </motion.div>
                )
    
    
    
    
            })
        )
    
  
}

export default SidePanel
